import { useMemo } from "react";
import { useBaseExplorer } from "@/hooks/useBaseExplorer";
import { applyAudienceFilter, type AudienceFilter } from "@/lib/campaigns/audience-query";

export function useAudiencePreview(filter: AudienceFilter) {
  const { data: rows = [], isLoading } = useBaseExplorer();

  const insights = useMemo(() => {
    if (isLoading) return null;
    const filteredRows = applyAudienceFilter(rows, filter);
    return {
      count: filteredRows.length,
      petCount: filteredRows.reduce((sum, row) => sum + row.pets.filter((pet) => pet.isAlive).length, 0),
      totalHistoricalSpent: filteredRows.reduce((sum, row) => sum + row.totalHistoricalSpent, 0),
      whatsappCount: filteredRows.filter((row) => row.hasWhatsApp).length,
    };
  }, [rows, isLoading, filter]);

  return {
    count: insights?.count ?? null,
    insights,
    isLoading,
  };
}
